import React from 'react'
import { BsFacebook,BsInstagram } from "react-icons/bs";
import { AiOutlineLinkedin,AiOutlineYoutube } from "react-icons/ai";
const Sidebox = () => {
  return (
    <div className="left-sidebar">
    <div className="sidebar-header d-flex align-items-center justify-content-center">
      <h1 style={{color:"#fff"}}>Portfo<span style={{color:"#00693E"}}>lio</span></h1>
    </div>
    <img className="me" src="assets/images/me.jpg" alt="Me" />
    <h2 className="email">azy6049@gmail.com</h2>
    <ul className="social-profile d-flex align-items-center flex-wrap justify-content-center">
      <li>
        <a target='_blank' href="https://www.facebook.com/profile.php?id=100092541834834&mibextid=ZbWKwL"><BsFacebook size={30} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.instagram.com/ajaybairwa4273/"><BsInstagram size={27} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.linkedin.com/in/ajay-bairwa-269921280/"><AiOutlineLinkedin size={30} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.youtube.com/@WebMastery009/about"><AiOutlineYoutube size={30}/></a>
      </li>
    </ul>
    <a href="#" className="theme-btn" style={{fontWeight: 700}}>
      <i className="las la-envelope" /> Hire Me!
    </a>
  </div>
  )
}

export default Sidebox